// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__20Bb9","rootSmall":"AddTileButton_rootSmall__2VP00"};